<!-- modal.component.html -->
<div class="modal-background" (click)="closeModal($event)" *ngIf="isOpen">
	<div class="modal-container" [class.fullscreen]="isFullscreen">
		<div class="header">
			<span class="title">{{ title }}</span>
			<div class="header-actions">
				<!-- Botão de expandir/reduzir -->
				<button class="icon-btn" (click)="toggleFullscreen(); $event.stopPropagation()">
					<fa-icon [icon]="isFullscreen ? icons.faCompress : icons.faExpand"></fa-icon>
				</button>
				<!-- Botão fechar -->
				<button class="icon-btn" (click)="closeModal()">
					<fa-icon [icon]="icons.faTimes"></fa-icon>
				</button>
			</div>
		</div>
		<div class="body">
			<ng-content select="[body]"></ng-content>
		</div>
		<div class="footer" *ngIf="showFooter">
			<ng-content select="[footer]"></ng-content>
		</div>
	</div>
</div>
